import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GamesService } from 'src/app/gamification/command-center/services/games.service';
import { GenericMetricFormatterPipe } from 'src/app/reusables/pipes/generic-metric-formatter.pipe';
import type { BaremetricsCalendar, BareMetricsCalendarPreset } from "src/app/reusables/baremetrics-calendar/baremetrics-calendar.component";

@Component({
  selector: 'cv-configure-estimator-popup',
  templateUrl: './configure-estimator-popup.component.html',
  styleUrls: ['./configure-estimator-popup.component.scss']
})

export class ConfigureEstimatorPopupComponent implements OnInit {
  isRaffle = false;
  gs: any = null;
  name: string;
  gamesData = [];
  loadingData: boolean = false;
  latestDate = new Date();
  selectedPreset: any;
  dateRangePresets: BareMetricsCalendarPreset[] = [];

  selectedStartDate: any;
  selectedEndDate: any;
  currentDate = new Date();

  constructor(
    private datePipe: DatePipe,
    private gamesService: GamesService,
    private activeModal: NgbActiveModal,
    private metricFormatPipe: GenericMetricFormatterPipe,
  ) { 
    this.gs = this.gamesService.data;
  }

  ngOnInit() {
    //Sort rewards of Milestone
    if (this.gs.selectedGame.length > 0 && this.gs.selectedGame[0].underlyingRule.GameType == 5) {
      this.gs.selectedGame[0].MilestoneRewards.sort((a: any, b: any) => { return (a.RuleLevelID < b.RuleLevelID) ? 1 : -1 });
    }

    this.selectedPreset = this.gs.modified.item.Schedule.IntervalType == "0" ? "Today" : this.gs.modified.item.Schedule.IntervalType == "1" ? "Last Week" : "Last Month";
    this.gs.selectedGame = [angular.copy(this.gs.modified.item)];

    this.loadDateRange();
  }

  loadDateRange (): void{
    let availableDates = [];
    switch (this.gs.modified.item.Schedule.IntervalType) {
      case "0":
        availableDates = [
          { name: "Today", displayName: "Today" },
          { name: "Yesterday", displayName: "Yesterday" },
          { name: "This Week", displayName: "This_Week" },
          { name: "Last Week", displayName: "Last_Week" },
          { name: "Last 2 Weeks", displayName: "Last_2_Weeks" }
        ];
        break;
      case "1":
        availableDates = [
          { name: "This Week", displayName: "This_Week" },
          { name: "Last Week", displayName: "Last_Week" },
          { name: "Last 2 Weeks", displayName: "Last_2_Weeks" },
          { name: "This Month", displayName: "This_Month" },
          { name: "Last Month", displayName: "Last_Month" }
        ];
        break;
      case "2":
        availableDates = [
          { name: "This Month", displayName: "This_Month" },
          { name: "Last Month", displayName: "Last_Month" },
          { name: "Last Quarter", displayName: "Last_Quarter" }
        ];
        break;
    };

    this.dateRangePresets = availableDates.map(dr => this.toBareMetricsPreset(dr));
  }

  toBareMetricsPreset(dateRange): BareMetricsCalendarPreset {
    return {
        name: dateRange.name,
        label: this.gamesService.getGamesHistoryMessages(dateRange.displayName, dateRange.displayName.replace("_", " ")),
        start: this.getStartDate(dateRange.name),
        end: this.getEndDate(dateRange.name)
    }
  }

  loadGamesData (calendar: BaremetricsCalendar){
    this.gamesData = [];
    let selectedStartDate = calendar.start_date.format(window['CVMomentDateFormat']);
    let selectedEndDate = calendar.end_date.format(window['CVMomentDateFormat']);
    this.loadingData = true;

    this.gamesService.getEstimatorData(selectedStartDate, selectedEndDate, this.gs.selectedGame[0]).then((result: any)=>{
      let currentGameObject = this.gs.selectedGame[0];
      result.data.rewardEstimatorObjects = this.setWinnersRaffle(result.data.rewardEstimatorObjects, currentGameObject);
      angular.forEach(result.data.rewardEstimatorObjects, (rewardEstParticipant) => {
        rewardEstParticipant.Interval.DisplayStringDate = this.datePipe.transform(rewardEstParticipant.Interval.StartDate, CVAngularDateFormat) + ' - ' + this.datePipe.transform(rewardEstParticipant.Interval.EndDate, CVAngularDateFormat);

        if (rewardEstParticipant.MetricData.MyRankingObj != null) {
          if (currentGameObject.Qualifier) {
            let Qualifier = rewardEstParticipant.MetricData.MyRankingObj.MetricGroupInfos.filter((a) => {
              return a.MetricID == currentGameObject.Qualifier.metricID;
            })[0];

            rewardEstParticipant.qualifier = Qualifier ? this.getFormattedMetric(Qualifier.MyMetricValue, currentGameObject.Qualifier.conversionType) : this.getFormattedMetric(0, currentGameObject.Qualifier.conversionType);
            rewardEstParticipant.passed = this.isQualified(currentGameObject, Qualifier && Qualifier.MyMetricValue ? Qualifier.MyMetricValue : 0);
          } else {
            rewardEstParticipant.qualifier = "";
            rewardEstParticipant.passed = false;
          }

          if (currentGameObject.underlyingRule.GameType == 6 || currentGameObject.underlyingRule.GameType == 7) {
            //Connect 3
            rewardEstParticipant.connect3Metrics = [];
            let metricCompleted = [];
            //Sort the Positions
            currentGameObject.Connect3Positions.sort((a, b) => {
              return (a.position > b.position) ? 1 : -1;
            });

            currentGameObject.Connect3Positions.forEach((metricPosition) => {
              let metric = rewardEstParticipant.MetricData.MyRankingObj.MetricGroupInfos.filter((a) => {
                return a.MetricID === metricPosition.metric.metricID;
              })[0];

              if (metric) {
                metric.metricCompleted = false;
                rewardEstParticipant.connect3Metrics.push(metric);
              } else {
                metric = { MetricID: metricPosition.metric.metricID, MyMetricValue: 0, metricCompleted: false };
                rewardEstParticipant.connect3Metrics.push(metric);
              }

              if (metricPosition.metric.metricID == -1) { 
                metricCompleted[metricPosition.position] = true; 
                rewardEstParticipant.connect3Metrics[metricPosition.position].metricCompleted = true; 
              } //Free Space = true

              if (metricPosition.metric != null && metricPosition.metric.metricID > -1 && metric != null) {
                metricCompleted[metricPosition.position] = metricPosition.targetObj.Direction == 0 ? metric.MyMetricValue < metricPosition.targetObj.Target : metric.MyMetricValue > metricPosition.targetObj.Target;
                rewardEstParticipant.connect3Metrics[metricPosition.position].metricCompleted = metricCompleted[metricPosition.position];
              }
            });

            //Connect3Rewards.ThreeInRow
            let isConnect3 = currentGameObject.underlyingRule.GameType == 6;
            
            if (currentGameObject.Qualifier) {
              if (rewardEstParticipant.passed) {
                let isWinner = isConnect3 ? this.isWinnerConnect3(metricCompleted, this.gs.winCasesConnect3) : this.isWinnerBlackout(metricCompleted, this.gs.winCasesBlackout);
                rewardEstParticipant.results = isConnect3 ? (isWinner ? "Connect3" : "No Connections") : (isWinner ? "ConnectAll" : "Not All Connected");
                if (isWinner) {
                  rewardEstParticipant.calculatedCoins = isConnect3 ? currentGameObject.Connect3Rewards.ThreeInRow.coins : currentGameObject.Connect3Rewards.Blackout.coins;
                  rewardEstParticipant.calculatedXP = isConnect3 ? currentGameObject.Connect3Rewards.ThreeInRow.xp : currentGameObject.Connect3Rewards.Blackout.xp;
                  rewardEstParticipant.badgeStringImage = isConnect3 ? (currentGameObject.Connect3Rewards.ThreeInRow.badge ? '<img src="../Admin/ImageResizer.aspx?imgid=' + currentGameObject.Connect3Rewards.ThreeInRow.badge + '&w=24&h=24" class="img-fluid" />' : '---') : (currentGameObject.Connect3Rewards.Blackout.badge ? '<img src="../Admin/ImageResizer.aspx?imgid=' + currentGameObject.Connect3Rewards.Blackout.badge + '&w=24&h=24" class="img-fluid" />' : '---');
                  rewardEstParticipant.badges = isConnect3 ? (currentGameObject.Connect3Rewards.ThreeInRow.badge ? [currentGameObject.Connect3Rewards.ThreeInRow.badge] : []) : (currentGameObject.Connect3Rewards.Blackout.badge ? [currentGameObject.Connect3Rewards.Blackout.badge] : []);
                }
              } else {
                rewardEstParticipant.results = this.getLocalizedText("Disqualified", "Disqualified");
              }
            } else {
              let isWinner = isConnect3 ? this.isWinnerConnect3(metricCompleted, this.gs.winCasesConnect3) : this.isWinnerBlackout(metricCompleted, this.gs.winCasesBlackout);

              rewardEstParticipant.results = isConnect3 ? (isWinner ? "Connect3" : "No Connections") : (isWinner ? "ConnectAll" : "Not All Connected");
              if (isWinner) {
                rewardEstParticipant.calculatedCoins = isConnect3 ? currentGameObject.Connect3Rewards.ThreeInRow.coins : currentGameObject.Connect3Rewards.Blackout.coins;
                rewardEstParticipant.calculatedXP = isConnect3 ? currentGameObject.Connect3Rewards.ThreeInRow.xp : currentGameObject.Connect3Rewards.Blackout.xp;
                rewardEstParticipant.badgeStringImage = isConnect3 ? (currentGameObject.Connect3Rewards.ThreeInRow.badge ? '<img src="../Admin/ImageResizer.aspx?imgid=' + currentGameObject.Connect3Rewards.ThreeInRow.badge + '&w=24&h=24" class="img-fluid" />' : '---') : (currentGameObject.Connect3Rewards.Blackout.badge ? '<img src="../Admin/ImageResizer.aspx?imgid=' + currentGameObject.Connect3Rewards.Blackout.badge + '&w=24&h=24" class="img-fluid" />' : '---');
                rewardEstParticipant.badges = isConnect3 ? (currentGameObject.Connect3Rewards.ThreeInRow.badge ? [currentGameObject.Connect3Rewards.ThreeInRow.badge]: []) : (currentGameObject.Connect3Rewards.Blackout.badge ? [currentGameObject.Connect3Rewards.Blackout.badge]: []);
              }
            }
          } else {
            if (rewardEstParticipant.MetricData && rewardEstParticipant.MetricData.MyRankingObj && rewardEstParticipant.MetricData.MyRankingObj.MetricGroupInfos && rewardEstParticipant.MetricData.MyRankingObj.MetricGroupInfos[0] && rewardEstParticipant.MetricData.MyRankingObj.MetricGroupInfos[0].MyMetricValue) {
              rewardEstParticipant.metric = this.getFormattedMetric(rewardEstParticipant.MetricData.MyRankingObj.MetricGroupInfos[0].MyMetricValue, currentGameObject.SelectedMetrics[0].conversionType);
          
              if (currentGameObject.Qualifier) {
                  let resultObject = this.getWinnerRank(currentGameObject, currentGameObject.underlyingRule.GameType, rewardEstParticipant.MetricData);
                  if (rewardEstParticipant.passed) {
                      rewardEstParticipant.results = resultObject.result;
                      rewardEstParticipant.calculatedCoins = resultObject.gameReward && resultObject.gameReward.Coins ? resultObject.gameReward.Coins.rewardValue : 0;
                      rewardEstParticipant.calculatedXP = resultObject.gameReward && resultObject.gameReward.XP ? resultObject.gameReward.XP.rewardValue : 0;
                      rewardEstParticipant.calculatedCustom = resultObject?.gameReward?.Custom && resultObject.gameReward.Custom.rewardValue ? resultObject.gameReward.Custom.rewardValue : '---';
                rewardEstParticipant.badgeStringImage = resultObject.gameReward && resultObject.gameReward.Badge && resultObject.gameReward.Badge.rewardValue ? '<img src="../Admin/ImageResizer.aspx?imgid=' + resultObject.gameReward.Badge.rewardValue + '&w=24&h=24" class="img-fluid" />' : '---';
                      rewardEstParticipant.badges = resultObject.gameReward && resultObject.gameReward.Badge && resultObject.gameReward.Badge.rewardValue ? (currentGameObject.underlyingRule.GameType == 5 ? resultObject.gameReward.Badge.rewardValue : [resultObject.gameReward.Badge.rewardValue]) : [];
                  } else {
                      rewardEstParticipant.results = this.getLocalizedText("Disqualified", "Disqualified");
                  }
              } else {
                  let resultObject = this.getWinnerRank(currentGameObject, currentGameObject.underlyingRule.GameType, rewardEstParticipant.MetricData);
          
                  rewardEstParticipant.results = resultObject.result;
                  rewardEstParticipant.calculatedCoins = resultObject.gameReward && resultObject.gameReward.Coins ? resultObject.gameReward.Coins.rewardValue : 0;
                  rewardEstParticipant.calculatedXP = resultObject.gameReward && resultObject.gameReward.XP ? resultObject.gameReward.XP.rewardValue : 0;
                  rewardEstParticipant.calculatedCustom = resultObject?.gameReward?.Custom && resultObject.gameReward.Custom.rewardValue ? resultObject.gameReward.Custom.rewardValue : '---';
              rewardEstParticipant.badgeStringImage = resultObject.gameReward && resultObject.gameReward.Badge && resultObject.gameReward.Badge.rewardValue ? '<img src="../Admin/ImageResizer.aspx?imgid=' + resultObject.gameReward.Badge.rewardValue + '&w=24&h=24" class="img-fluid" />' : '---';
                  rewardEstParticipant.badges = resultObject.gameReward && resultObject.gameReward.Badge && resultObject.gameReward.Badge.rewardValue ? (currentGameObject.underlyingRule.GameType == 5 ? resultObject.gameReward.Badge.rewardValue : [resultObject.gameReward.Badge.rewardValue]) : [];
              }
            }
            else if (currentGameObject.underlyingRule.GameType === 9){
              rewardEstParticipant.results = this.getLocalizedText("No_Results", "No Results");
            }          
          }
        } else {
          rewardEstParticipant.metric = "";
          rewardEstParticipant.qualifier = "";
          rewardEstParticipant.passed = false;
          rewardEstParticipant.results = this.getLocalizedText("No_Results", "No Results");
        }
      });

      this.loadingData = false;
      this.gamesData = result.data.rewardEstimatorObjects.map(data => ({
        ...data,
        calculatedCoins: data.calculatedCoins ? data.calculatedCoins : '---',
        calculatedXP: data.calculatedXP ? data.calculatedXP : '---',
        calculatedCustom: data.calculatedCustom ? data.calculatedCustom: '---',
      }));
    });
  }

  close(): void{
    this.activeModal.close();
  }

  onExport (): void {
    this.gamesService.getExportEstimatorData(this.selectedStartDate, this.selectedEndDate, { reObjects: this.gamesData, game: this.gs.modified.item }).then((result) => {
      let fileName = this.gs.modified.item.underlyingRule.RuleName + "_" + (new Date()).toString('yyyymmddhhmmss');
        this.downloadFile(result, "excel", fileName + ".xlsx");
    });
  }
  
  getWinnerRank(game: any, gameType: number, ruleObject: any): any {
    let result: string;
    let gameReward: any;

    switch (gameType) {
      case 1: //Multiplier Madness
        result = this.getLocalizedText("No_Results", "No Results");
        gameReward = {
          Coins: {
            rewardValue: game.MultiplierMadnessRewards.hasMaxCoins && (game.MultiplierMadnessRewards.coins * ruleObject.MyRankingObj.MetricGroupInfos[0].MyMetricValue) > game.MultiplierMadnessRewards.maxCoinsPayout ? game.MultiplierMadnessRewards.maxCoinsPayout : game.MultiplierMadnessRewards.coins * ruleObject.MyRankingObj.MetricGroupInfos[0].MyMetricValue,
          },
          XP: {
            rewardValue: game.MultiplierMadnessRewards.hasMaxXP && (game.MultiplierMadnessRewards.xp * ruleObject.MyRankingObj.MetricGroupInfos[0].MyMetricValue) > game.MultiplierMadnessRewards.maxXpPayout ? game.MultiplierMadnessRewards.maxXpPayout : game.MultiplierMadnessRewards.xp * ruleObject.MyRankingObj.MetricGroupInfos[0].MyMetricValue,
          }
        };
        
        return { result: result, gameReward: gameReward };
      case 2: //TopDog
        result = this.getLocalizedText("No_Results", "No Results");
        gameReward = null;
        
        game.TopDogRewards.forEach((reward, index) => {
          let isWinnerTD = this.isWinnerTopDog(game, index, ruleObject);
          if (isWinnerTD) {
            result = isWinnerTD;
            gameReward = reward;
          }
        })

        return { result: result, gameReward: gameReward };
      case 3: //Bullseye
        result = this.getLocalizedText("No_Results", "No Results");
        gameReward = null;
        
        game.BullseyeRewards.forEach((reward, index) => {
          let isWinnerBe = this.isWinnerBullseye(game, index, ruleObject);
          if (isWinnerBe) {
            result = isWinnerBe;
            gameReward = reward;
          }
        })

        return { result: result, gameReward: gameReward }
      case 5: //Milestone
        result = 'No Milestones';
        gameReward = null;
        let sumCoins = { rewardValue: 0 };
        let sumXP = { rewardValue: 0 };
        let arrBadges = { rewardValue: [] };
        const milestoneWin = [];

        game.MilestoneRewards.forEach((reward: any, index: number) => {
          let isWinnerMi = this.isWinnerMilestone(game, index, ruleObject);
          if (isWinnerMi) {
            milestoneWin.push(reward.Index);
            sumCoins.rewardValue += reward.Coins.rewardValue;
            sumXP.rewardValue += reward.XP.rewardValue;
            if (reward.Badge && reward.Badge.rewardValue)
              arrBadges.rewardValue.push(reward.Badge.rewardValue);
          }
        });

        if (milestoneWin.length > 0) {
          result = 'Milestone ' + Math.max(...milestoneWin);
        }
        gameReward = {
          Coins: sumCoins,
          XP: sumXP,
          Badge: arrBadges
        };

        return { result: result, gameReward: gameReward };
      case 8: // TopTeam
        result = this.getLocalizedText("No_Results", "No Results");
        gameReward = null;

        game.TopDogRewards.forEach((reward, index) => {
          let isWinnerTD = this.isWinnerTopDog(game, index, ruleObject);
          if (isWinnerTD) {
            result = isWinnerTD;
            gameReward = reward;
          }
        })

        return { result: result, gameReward: gameReward };
      case 9: 
        const coins = ruleObject?.MyRankingObj?.CoinsAmount > 0 && ruleObject?.MyRankingObj?.HasCoinAction ? {
          Coins: {
            rewardValue: ruleObject?.MyRankingObj?.CoinsAmount,
          }
        } : {};
        const xp = ruleObject?.MyRankingObj?.XPAmount > 0 && ruleObject?.MyRankingObj?.HasXPAction ? {
          XP: {
            rewardValue: ruleObject?.MyRankingObj?.XPAmount,
          }
        } : {};
        const custom = ruleObject?.MyRankingObj?.CustomValue && ruleObject?.MyRankingObj?.HasCustomAction ? {
          Custom: {
            rewardValue: ruleObject?.MyRankingObj?.CustomValue,
          }
        } : {};
        const raffleResult = this.isWinnerRaffle(ruleObject?.MyRankingObj, game);
        gameReward = {
          ...coins,
          ...xp,
          ...custom,
        };

        return { result: raffleResult, gameReward: gameReward };
    }
  }

  isWinnerTopDog(gamedata, index: number, gameranking) {
    if (gameranking == undefined || gameranking == null || gameranking.MyRankingObj == null 
      || gameranking.MyRankingObj.MetricGroupInfos == undefined || gameranking.MyRankingObj.MetricGroupInfos == null) return "";
    
      //Check if the game has qualifier metric
    if (gamedata.Qualifier != null && gameranking.MyRankingObj.MetricGroupInfos.length > 1) {
      if (gameranking.MyRankingObj.MyRanking == (index + 1) && this.isQualified(gamedata, gameranking.MyRankingObj.MetricGroupInfos[1].MyMetricValue))
          return this.getLocalizedTierText(gameranking.MyRankingObj.MyRanking, 2);
    } else {
      //the game doesn't have qualifier metric
      if (gameranking.MyRankingObj.MyRanking == (index + 1))
        return this.getLocalizedTierText(gameranking.MyRankingObj.MyRanking, 2);
    }
  }

  isWinnerRaffle(MyRankingObj, game?: any): string {
    if(MyRankingObj.HasCoinAction || MyRankingObj.HasXPAction || MyRankingObj.HasCustomAction){
      return this.getLocalizedText("Winner", "Winner");
    }
    if(game && MyRankingObj && this.couldWinPrize(game, MyRankingObj)) return this.getLocalizedText("Raffle_Participant", "Raffle participant");
    if (MyRankingObj.MyRanking < MyRankingObj.TotalParticipants && MyRankingObj.Score != 0) return this.getLocalizedText("No_ticket", "No Ticket");
    return this.getLocalizedText("No_Results", "No Results");
  }

  couldWinPrize(game, MyRankingObj){
    let isQualifiedFlag = null;
    const metricValue: number = MyRankingObj.MetricGroupInfos[0]?.MyMetricValue;

    if (!!game.QualifierLevels) {
      isQualifiedFlag = this.isQualified(game, metricValue);
    }
    let isWinner = false;
    const minValue: number = game.RaffleLevels.leftNumber;
    const maxValue: number = game.RaffleLevels.rightNumber;
    if (game.RaffleLevels.comparerType == 1) { //Greater than
      isWinner = metricValue >= minValue;
    } else if(game.RaffleLevels.comparerType == 2){ // Less than
      isWinner = metricValue <= minValue;
    } else {
      isWinner = metricValue >= minValue && metricValue <= maxValue;
    }
    //Game has Qualifier
    if (game.Qualifier != null && isQualifiedFlag && isWinner) {
      return true;
    }
    // Game has no Qualifier
    else if (game.Qualifier == null && !isQualifiedFlag && isWinner) {
      return true;
    }
    return false;
  }

  getRaffleParticipants(data, game) {
    const participants = data.filter(participant => {
      return participant.MetricData && participant.MetricData.MyRankingObj && participant.MetricData.MyRankingObj.MetricGroupInfos[0]?.MyMetricValue && this.couldWinPrize(game, participant.MetricData.MyRankingObj);
    });
    return participants.sort((a, b) => {
      return a.Participant.participant.LoginName.localeCompare(b.Participant.participant.LoginName);
    }); 
  }

  setWinnersRaffle(data: any[], game) {
    if(game.underlyingRule.GameType !== 9) return data; // if not a raffle game
    const raffleParticipants = this.getRaffleParticipants(data, game);
    const allIntervals = data.reduce((acc, intervals)=> ({
      ...acc,
      [intervals?.Interval?.StartDate]: 0,
    }), {}); // all interval in format { [StartDate]: number }, the number will be how many prize we spend in this interval
    const RaffleRewards: any[] = game.RaffleRewards;

    Object.keys(allIntervals).forEach(interval => {
      const raffleInterval = raffleParticipants.filter(p => p.Interval.StartDate === interval);
      RaffleRewards.forEach((reward, i) => {
        if(raffleInterval[i]){
          raffleInterval[i].MetricData.MyRankingObj.CoinsAmount = reward.Coins.rewardValue;
          raffleInterval[i].MetricData.MyRankingObj.HasCoinAction = reward.Coins.rewardValue > 0 && reward.isSystemReward;
          raffleInterval[i].MetricData.MyRankingObj.XPAmount = reward.XP.rewardValue;
          raffleInterval[i].MetricData.MyRankingObj.HasXPAction = reward.XP.rewardValue > 0 && reward.isSystemReward;
          raffleInterval[i].MetricData.MyRankingObj.CustomValue = reward.Custom.rewardText;
          raffleInterval[i].MetricData.MyRankingObj.HasCustomAction = reward.Custom.rewardText.length > 0 && !reward.isSystemReward;
        }
      });
    });
    return data.sort((a, b)=> {
      if(!b.MetricData.MyRankingObj || !a.MetricData.MyRankingObj) return 0;
      if(a.MetricData.MyRankingObj.CoinsAmount !=  b.MetricData.MyRankingObj.CoinsAmount){
        return b.MetricData.MyRankingObj.CoinsAmount - a.MetricData.MyRankingObj.CoinsAmount;
      }
      if(a.MetricData.MyRankingObj.XPAmount !=  b.MetricData.MyRankingObj.XPAmount){
        return b.MetricData.MyRankingObj.XPAmount - a.MetricData.MyRankingObj.XPAmount;
      }
      if(a.MetricData.MyRankingObj.CustomValue) {
        if(b.MetricData.MyRankingObj.CustomValue) return b.MetricData.MyRankingObj.CustomValue.localeCompare(a.MetricData.MyRankingObj.CustomValue);
        return -1;
      }
      return 0;
    });
  }
  
  isWinnerBullseye(game, index: number, gameranking) {
    if (gameranking == undefined || gameranking == null ||
      gameranking.MyRankingObj == undefined || gameranking.MyRankingObj == null) return "";

    let metricValue = gameranking.MyRankingObj.MetricGroupInfos.length > 0 ? gameranking.MyRankingObj.MetricGroupInfos[0].MyMetricValue : 0;
    let minValue = game.BullseyeRewards[index].Target.Val1;
    let maxValue = game.BullseyeRewards[index].Target.Val2;
    
    switch (parseInt(game.BullseyeRewards[index].ComparisonType)) {
      case 1: // Greater than
        //Check if the game has qualifier
        if (game.Qualifier != null) {
          if (metricValue >= minValue && this.isQualified(game, gameranking.MyRankingObj.MetricGroupInfos[1].MyMetricValue))
            return this.getLocalizedTierText(index + 1, 3);
        } else {
          if (metricValue >= minValue)
            return this.getLocalizedTierText(index + 1, 3);
        }
        break;

      case 2: // Less than
        //Check if the game has qualifier
        if (game.Qualifier != null) {
          if (metricValue <= minValue && this.isQualified(game, gameranking.MyRankingObj.MetricGroupInfos[1].MyMetricValue))
            return this.getLocalizedTierText(index + 1, 3);
        } else {
          if (metricValue <= minValue)
            return this.getLocalizedTierText(index + 1, 3);
        }
        break;

      case 3: // Between
        //Prepare variables for comparing process
        if (game.SelectedMetrics[0].direction == "1"){ // Up Metrics
          if (game.Qualifier != null) {
            if (metricValue >= minValue && metricValue <= maxValue && this.isQualified(game, gameranking.MyRankingObj.MetricGroupInfos[1].MyMetricValue))
              return this.getLocalizedTierText(index + 1, 3);
          } else {
            if (metricValue >= minValue && metricValue <= maxValue)
              return this.getLocalizedTierText(index + 1, 3);
          }
        } else {
          if (game.Qualifier != null) {
            if (metricValue >= maxValue && metricValue <= minValue && this.isQualified(game, gameranking.MyRankingObj.MetricGroupInfos[1].MyMetricValue))
              return this.getLocalizedTierText(index + 1, 3);
          } else {
            if (metricValue >= maxValue && metricValue <= minValue)
              return this.getLocalizedTierText(index + 1, 3);
          }
        }
        break;
    }
  }

  isWinnerMilestone(gamedata: any, index: number, gameranking) {
    if (gameranking == undefined || gameranking == null || gameranking.MyRankingObj == undefined || gameranking.MyRankingObj == null) 
      return "";
    
    //Game has Qualifier
    let isQualifiedFlag = null;
    if (gamedata.Qualifier != null) {
        isQualifiedFlag = this.isQualified(gamedata, gameranking.MyRankingObj.MetricGroupInfos[1].MyMetricValue);
    }

    //Prepare variables for comparing process 
    let metricValue = gameranking.MyRankingObj.MetricGroupInfos.length > 0 ?  gameranking.MyRankingObj.MetricGroupInfos[0].MyMetricValue : 0;
    let minValue = gamedata.MilestoneRewards[index].Target.Val1;
    let maxValue = gamedata.MilestoneRewards[index].Target.Val2;
    let isWinner = false;

    if (gamedata.SelectedMetrics[0].direction == "1"){ // Up Metrics    
      if (gamedata.MilestoneRewards[index].ComparisonType == 1) { //Greater than
        isWinner = (metricValue >= minValue) ? true : false;
      } else {
        isWinner = (metricValue >= maxValue || (metricValue >= minValue && metricValue <= maxValue)) ? true : false;
      }
    } else {  // Down Metrics
      if (gamedata.MilestoneRewards[index].ComparisonType == 2) { //Less than
        isWinner = (metricValue <= minValue) ? true : false;
      }
      else {
        isWinner = (metricValue <= maxValue || (metricValue <= maxValue && metricValue >= minValue)) ? true : false;
      }
    }

    //Game has Qualifier
    if (gamedata.Qualifier != null && isQualifiedFlag && isWinner) {
        return true;
    }

    // Game has no Qualifier
    else if (gamedata.Qualifier == null && isQualifiedFlag == null && isWinner) {
        return true;
    }
    return false;
  }

  isWinnerConnect3(metricCompleted, winCasesConnect3): boolean {
    let bin = 0;

    for (let i = 0; i < metricCompleted.length; i++) {
      bin += (metricCompleted[i]) ? Math.pow(2, i) : 0;
    }

    for (let i = 0; i < winCasesConnect3.length; i++) {
      let result = bin & winCasesConnect3[i];
      if (result === winCasesConnect3[i])
        return true;
    }
    return false;
  }

  isWinnerBlackout(metricCompleted, winCasesBlackout): boolean {
    let bin = 0;

    for (let i = 0; i < metricCompleted.length; i++) {
      bin += (metricCompleted[i]) ? Math.pow(2, i) : 0;
    }

    for (let i = 0; i < winCasesBlackout.length; i++) {
      let result = bin & winCasesBlackout[i];
      if (result === winCasesBlackout[i])
        return true;
    }
    return false;
  }

  getLocalizedTierText(tier: number, gameType: number): string {
    switch (tier) {
      case 1:
        if (gameType == 2) { // TopDog
          return this.getLocalizedText("First_Place", "1st Place");
        } else if (gameType == 3) { // Bullseye
          return this.getLocalizedText("Ring_Prize", "Bullseye");
        }
        break;
      case 2:
        if (gameType == 2) { // TopDog
          return this.getLocalizedText("Second_Place", "2nd Place");
        } else if (gameType == 3) { // Bullseye
          return this.getLocalizedText("2nd_Ring", "2nd Ring");
        }
        break;
      case 3:
        if (gameType == 2) { // TopDog
          return this.getLocalizedText("Third_Place", "3rd Place");
        } else if (gameType == 3) { // Bullseye
          return this.getLocalizedText("3rd_Ring", "3rd Ring");
        }
        break;
      default:
        let number = tier + this.getLocalizedText("Th_Symbol", "th") + " ";
        if (gameType == 2) { // TopDog
          number += this.getLocalizedText("Place", "Place");
        } else if (gameType == 3) { //Bullseye
          number += this.getLocalizedText("Ring", "Ring");
        }
        return number;
    }
  }
  
  isQualified(game: any, myValue: number) {
    let isQualified = false;
    if (game == undefined || game == null || game.Qualifier == null) return false;
    
    switch (parseInt(game.QualifierLevels.comparerType)) {
      case 1: // Greater than
        if (myValue > game.QualifierLevels.leftNumber)
          isQualified = true;
        break;
      case 2: // Less than
        if (myValue < game.QualifierLevels.leftNumber)
          isQualified = true;
        break;
      case 3: // Between
        if (myValue >= game.QualifierLevels.leftNumber && myValue <= game.QualifierLevels.rightNumber)
          isQualified = true;
        break;
      default:
        return
        break;
    }
    return isQualified;
  }
  
  getStartDate(name: string): any {
    //The following code make use of DateJS
    const today = Date.today()
    const cvWeekStart = window['CVWeekStart']
    let thisWeekStart = today.getDay() == cvWeekStart ? today : today.moveToDayOfWeek(cvWeekStart, -1);

    switch (name) {
      case "Today":
        return Date.today();
      case "This Week":
        return thisWeekStart;
      case "This Month":
        return Date.today().moveToFirstDayOfMonth();
      case "Yesterday":
        return Date.today().addDays(-1);
      case "Last Week":
        return thisWeekStart.clone().addDays(-7);
      case "Last 2 Weeks":
        return thisWeekStart.clone().addDays(-14);
      case "Last Month":
        return Date.today().moveToFirstDayOfMonth().addMonths(-1);
      case "Last Quarter":
        let lastQuarterStart = ((((Date.today().getMonth() - 1) / 3) - 1) * 3);
        return new Date(Date.today().getFullYear(), lastQuarterStart, 1);
      default:
        let dates = this.name.split(' - ');
        if (dates.length < 2)
          return Date.today();
        else 
          return Date.parseExact(dates[0], window['CVAngularDateFormat']) || Date.today();
    }
  }
  
  getEndDate(name: string): any {
    //The following code make use of DateJS
    const today = Date.today()
    const cvWeekStart = window['CVWeekStart']
    let thisWeekStart = today.getDay() == cvWeekStart ? today : today.moveToDayOfWeek(cvWeekStart, -1);

    switch (name) {
      case "Today":
        return Date.today();
      case "This Week":
        return thisWeekStart.clone().addDays(6);
      case "This Month":
        return Date.today().moveToLastDayOfMonth();
      case "Yesterday":
        return Date.today().addDays(-1);
      case "Last Week":
      case "Last 2 Weeks":
        return thisWeekStart.clone().addDays(-1);
      case "Last Month":
        return Date.today().moveToFirstDayOfMonth().addDays(-1);
      case "Last Quarter":
        let lastQuarterStart = ((((Date.today().getMonth() - 1) / 3) - 1) * 3);
        return (new Date(Date.today().getFullYear(), lastQuarterStart + 2, 1)).moveToLastDayOfMonth();
      default:
        let dates = this.name.split(' - ');
        
        if (dates.length < 2)
          return Date.today();
        else 
          return Date.parseExact(dates[1], window['CVAngularDateFormat']) || Date.today();
    }
  }

  /**
  * Downloads a file from a byte array string
  *
  * @param {string} data The byte[] string returned from the endpoint
  * @param {string} mime The mime type to mark the file as
  * @param {string} fileName The name of the file to be downloaded
  * @memberof ModuleContainerComponent
  */

  downloadFile(data, mime, fileName: string) {
    let decodedData = atob(data);
    let buffer = new ArrayBuffer(decodedData.length);
    let view = new Uint8Array(buffer);

    for (let i = 0; i != decodedData.length; ++i) {
      view[i] = decodedData.charCodeAt(i) & 0xFF;
    }

    let fileData = [buffer];
    let blobObject = new Blob(fileData, { type: mime });

    /*if (window.navigator.msSaveOrOpenBlob) { // IE11 blob download
        window.navigator.msSaveOrOpenBlob(blobObject, fileName);
    } else { */ // non-IE
        // Create fake link
        let linkElement = document.createElement('a');
        document.body.appendChild(linkElement);
        linkElement.setAttribute('style', 'display: none;');

        let url = URL.createObjectURL(blobObject);
        linkElement.href = url;
        linkElement.download = fileName;

        // Start download
        linkElement.click();

        // Cleanup
        URL.revokeObjectURL(linkElement.href);
        linkElement.remove();
    //}
  }

  getFormattedMetric(value: number, format: string): string{
    return this.metricFormatPipe.transform(value, format);
  }

  getLocalizedText(key: string, defaultText: string): string{
    return this.gamesService.getLocalizedMessage(key, defaultText);
  }
}
